import type { EventContext } from '@moeru/eventa'

import type { TelegramApplication } from '../application/runtime'

import { registerChatHandlers } from './chats'
import { registerExportHandler } from './export'
import { registerMediaHandlers } from './media'
import { registerMessageHandlers } from './messages'
import { registerStatsHandler } from './stats'
import { registerSyncHandler } from './sync'

export function registerApplicationHandlers(context: EventContext<any, any>, application: TelegramApplication): () => void {
  const chatDisposers = registerChatHandlers(context, application)
  const messageDisposers = registerMessageHandlers(context, application)
  const mediaDisposers = registerMediaHandlers(context, application)
  const disposeStats = registerStatsHandler(context, application)
  registerSyncHandler(context, application)
  // NOTICE: exportLocal is absent in browser runtimes (see application/runtime.ts), so its
  // presence alone determines whether the Node-only export handler should be registered.
  if (application.exportLocal) {
    registerExportHandler(context, {
      ...application,
      exportLocal: application.exportLocal,
    })
  }
  return () => {
    disposeStats()
    for (const dispose of [...Object.values(chatDisposers), ...Object.values(messageDisposers), ...Object.values(mediaDisposers)]) {
      dispose()
    }
  }
}
